(function () {
  function initFeaturedTextLoadMore() {
    document.querySelectorAll("[data-featured-text-load-more]").forEach(
      function (loadMoreBtn) {
        if (loadMoreBtn.getAttribute("data-featured-text-bound") === "true") {
          return;
        }
        loadMoreBtn.setAttribute("data-featured-text-bound", "true");

        var root = loadMoreBtn.closest(".featured-content-section") ||
          loadMoreBtn.closest(".shopify-section");
        if (!root) return;

        var panelId = loadMoreBtn.getAttribute("aria-controls");
        var hiddenArea = null;
        if (panelId) {
          try {
            hiddenArea = root.querySelector("#" + CSS.escape(panelId));
          } catch (err) {
            hiddenArea = root.querySelector(
              '[id="' + panelId.replace(/"/g, '\\"') + '"]',
            );
          }
        }
        if (!hiddenArea) {
          hiddenArea = root.querySelector(".load-more-main-hidden");
        }
        if (!hiddenArea) return;

        hiddenArea.style.maxHeight = "0";
        hiddenArea.style.overflow = "hidden";
        hiddenArea.style.opacity = "0";

        var labelMore = loadMoreBtn.getAttribute("data-label-more") ||
          loadMoreBtn.textContent;
        var labelLess = loadMoreBtn.getAttribute("data-label-less") ||
          "Read less";

        loadMoreBtn.addEventListener("click", function (e) {
          e.preventDefault();
          var isExpanded = hiddenArea.classList.toggle("expanded");
          if (isExpanded) {
            hiddenArea.style.maxHeight = hiddenArea.scrollHeight + "px";
            hiddenArea.style.opacity = "1";
            loadMoreBtn.textContent = labelLess;
            loadMoreBtn.setAttribute("aria-expanded", "true");
          } else {
            hiddenArea.style.maxHeight = "0";
            hiddenArea.style.opacity = "0";
            loadMoreBtn.textContent = labelMore;
            loadMoreBtn.setAttribute("aria-expanded", "false");
          }
        });
      },
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFeaturedTextLoadMore);
  } else {
    initFeaturedTextLoadMore();
  }

  document.addEventListener("shopify:section:load", initFeaturedTextLoadMore);
})();
